<script>
import formRules from '@/mixins/formRules';
import stagingAPI from '@/api/staging';
import Icon from './table/Icon';

export default {
  name: 'staging-project',
  mixins: [formRules],
  props: {
    staging_project_id: {
      required: true
    },
    show_dialog: {
      required: true,
      type: Boolean
    },
    icon: {
      required: true,
      type: String
    },
    icon_color: {
      required: true,
      type: String
    },
    timeline_items: {
      required: true,
      type: Array
    },
    stage_items: {
      required: true,
      type: Array
    },
    show_dates: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    staging_project: {},
    loading: false,
    show_log_entry: false,
    show_move: false,
    show_po: false,
    show_timeline: false,
    show_cancel: false,
    confirm_uncancel: false,
    show_conflict_resolution: false,
    show_service_overview: false,
    start_date: '',
    end_date: '',
    is_details_form_valid: false,
    show_activate: false,
    show_activate_only: false,
    is_saving: false,
    action_taken: '',
    log_entry: { action_taken: "", taken_by: "", date: "", time: "" },
  }),
  mounted() {
    this.getData();
  },
  watch: {
    staging_project_id: {
      deep: true,
      handler: function (old_project, project) {
        if (old_project !== project) {
          this.getData();
        }
      }
    }
  },
  computed: {
    isLocked() {
      const date = new Date();
      const date_array = this.staging_project.last_updated.split("-");
      const last_updated_year = date_array[0];
      const last_updated_month = date_array[1];
      const last_updated_day = date_array[2];

      if (
        date.getFullYear() === Number(last_updated_year) &&
        (date.getMonth() + 1) === Number(last_updated_month) &&
        date.getDate() === Number(last_updated_day)
      ) {
        return true;
      }
      return false;
    },
    status() {
      if (this.staging_project.resolution === 'D') {
        return " Cancelled/Declined";
      }
      else if (this.staging_project.resolution === 'A') {
        return " Project Activated";
      }
      else if (this.staging_project.on_hold) {
        return " On Hold"
      }
      else if (this.staging_project.stage === 0) {
        return " Staging Initiated";
      }
      else if (this.staging_project.stage === 1) {
        return " Contact Sent";
      }
      else if (this.staging_project.stage === 2) {
        return " Offer Sent";
      }
      else if (this.staging_project.stage === 3) {
        return " Confirmation Sent";
      } else if (this.staging_project.stage === 4 && this.staging_project.type === 'B') {
        return " Early Blowdown";
      }
      return "";
    },
    conflict_class() {
      if (this.staging_project.has_serious_conflicts) {
        return "error";
      }
      else if (this.staging_project.has_conflicts) {
        return "orange darken-1";
      }
      return "grey darken-1";
    },
    pre_check() {
      return this.staging_project.pre_check_required && !this.staging_project.resolved;
    },
    cancel_text() {
      let text = 'Are you sure you want to cancel staging this project?';
      if (this.staging_project.resolution === 'A') {
        text += ' This project has already moved forward all invoices and work orders will be cancelled.';
      }
      return text;
    }
  },
  methods: {
    async getData() {
      this.staging_project = await stagingAPI.getStagingProject(this.staging_project_id);
    },
    open() {
      this.$emit('open', this.staging_project.project_data);
    },
    activate() {
      this.is_saving = true;
      this.$emit('activateStagingProject', this.staging_project.id);
      this.show_activate = false;
      this.is_saving = false;
    },
    overrideLock() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const date_string = yesterday.toISOString().split('T')[0];
      this.staging_project.last_updated = date_string;
      stagingAPI.updateStagingProject(this.staging_project, this.staging_project.id, this.$store.state.auth.profile.id);
    },
    close() {
      console.log(this.show_dialog);
      this.$emit('close');
    },
    async resolveConflicts() {
      let ids = [];
      this.staging_project.conflict_data.map((conflict) => {
        ids.push(conflict.id);
      });
      const returned_project = await stagingAPI.updateConflicts(this.staging_project.id, this.$store.state.auth.profile.id);
      this.staging_project.conflict_data = returned_project.conflict_data;
      this.staging_project.has_conflicts = returned_project.has_conflicts;
      this.staging_project.has_serious_conflicts = returned_project.has_serious_conflicts;
      this.staging_project.log_data = returned_project.log_data;
      const staging_projects = [returned_project];
      this.$emit('updateStagingProject', staging_projects);
      this.show_conflict_resolution = false;
    },
    cancel() {
      this.$emit('cancelStaging', this.staging_project.id);
      this.show_cancel = false;
    },
    showLog() {
      this.log_entry = "";
      this.show_log_entry = true;
    },
    async createNewLog() {
      const log_entry = {};
      log_entry.taken_by = this.$store.state.auth.profile.id;
      log_entry.staging_project = this.staging_project.id;
      log_entry.action_taken = this.action_taken;
      const log = await stagingAPI.createLog(log_entry);
      this.staging_project.log_data.push(log);
      this.show_log_entry = false;
      this.action_taken = '';
    },
    openInvoice(invoice) {
      const link = document.createElement('a')
      const invURL = this.$router.resolve({ name: 'InvoiceOverview', params: { id: invoice.invoice } })
      link.target = '_blank'
      link.href = invURL.href
      link.click()
    },
    openWorkOrder(work_order) {
      const link = document.createElement('a')
      const invURL = this.$router.resolve({ name: 'WOOverview', params: { id: work_order.work_order } })
      link.target = '_blank'
      link.href = invURL.href
      link.click()
    },
    editNotice() {
      const link = document.createElement('a');
      const invURL = this.$router.resolve({ name: 'NoticesDashboard' });
      link.target = '_blank';
      link.href = invURL.href;
      link.click();
    },
    saveDates() {
      const new_staging_project = {
        "start_date": this.staging_project.start_date,
        "end_date": this.staging_project.end_date
      }

      stagingAPI.updateStagingProject(new_staging_project, this.staging_project.id, this.$store.state.auth.profile.id);
      this.show_service_overview = false;
    },
    async updatePO() {
      const new_staging_project = {
        "po": this.staging_project.po
      }

      const returned_project = await stagingAPI.updateStagingProject(new_staging_project, this.staging_project.id, this.$store.state.auth.profile.id);
      const projects = [returned_project];
      this.$emit('updateStagingProject', projects);
      this.show_po = false;
    },
    async updateTimeline() {
      const new_staging_project = {
        "timeline": this.staging_project.timeline
      }

      if (
        this.staging_project.type === "B" &&
        (new_staging_project.timeline === "PO1" ||
          new_staging_project.timeline === "PS6" ||
          new_staging_project.timeline === "S20")) {
        new_staging_project.stage = 4;
      }
      else if (this.staging_project.type === "B" && new_staging_project.timeline === "NTL") {
        new_staging_project.stage = 3;
      }
      else if (this.staging_project.type === "B" && new_staging_project.timeline === "ERS10") {
        new_staging_project.stage = 2;
      }
      else if (this.staging_project.type === "U" && new_staging_project.timeline === "NTL") {
        new_staging_project.stage = 2;
      }
      else if (this.staging_project.type === "U" && new_staging_project.timeline === "BM8") {
        new_staging_project.stage = 3;
      }
      else if (this.staging_project.type == "U" && new_staging_project.timeline == "AM8") {
        new_staging_project.stage = 4;
      }

      const returned_project = await stagingAPI.updateStagingProject(new_staging_project, this.staging_project.id, this.$store.state.auth.profile.id);
      const projects = [returned_project];
      this.$emit('updateStagingProject', projects);
      this.show_timeline = false;
    },
    uncancelStaging() {
      this.staging_project.resolution = 'I';
      this.staging_project.resolved = false;
      this.confirm_uncancel = false;
      this.moveStagingProject();
    },
    moveTimeline(staging_project) {
      if (this.staging_project.type === "B") {
        if (staging_project.stage === 2) {
          staging_project.timeline = "ERS10";
          this.staging_project.timeline = "ERS10";
        }
        else if (staging_project.stage === 3) {
          staging_project.timeline = "NTL";
          this.staging_project.timeline = "NTL";
        }
        else if (staging_project.stage === 4) {
          staging_project.timeline = "PO1";
          this.staging_project.timeline = "PO1";
        }
      }
      else if (this.staging_project.type === "U") {
        if (staging_project.stage === 2) {
          staging_project.timeline = "NTL";
          this.staging_project.timeline = "NTL";
        }
        else if (staging_project.stage === 3) {
          staging_project.timeline = "BM8";
          this.staging_project.timeline = "BM8";
        }
        else if (staging_project.stage === 4) {
          staging_project.timeline = "AM8";
          this.staging_project.timeline = "AM8";
        }
      }
    },
    async moveStagingProject() {
      const new_staging_project = {
        "stage": this.staging_project.stage,
        "resolution": this.staging_project.resolution,
        "resolved": this.staging_project.resolved
      }

      this.moveTimeline(new_staging_project);

      if (this.staging_project.resolution === 'D') {
        this.confirm_uncancel = true;
        return;
      }

      const returned_project = await stagingAPI.updateStagingProject(
        new_staging_project,
        this.staging_project.id,
        this.$store.state.auth.profile.id
      );

      const projects = [returned_project];
      this.$emit('updateStagingProject', projects);
      this.show_move = false;
    },
    async activateOnly() {
      const returned_project = await stagingAPI.activateOnlyStagingProject(this.staging_project, this.staging_project.id);
      const projects = [returned_project];
      this.$emit('updateStagingProject', projects);
      this.show_activate_only = false;
    },
    downloadSnailMail() {
      const link = document.createElement('a');
      const previewURL = this.$axios.defaults.baseURL + 'download-snail-mail/' + this.staging_project.id;
      link.target = '_blank';
      link.href = previewURL;
      link.click();
    },
    loadNext() {
      this.$emit('nextProject');
    },
    loadPrev() {
      this.$emit('prevProject');
    }
  },
  components: {
    'staging-table-icon': Icon
  }
}
</script>

<template>
  <div>
    <wc-dialog :showDialog='show_dialog' :loading='loading' title='Staging Project View' subtitle='' width='1000'
      :loadingButtons='loading' :hideSave='true' saveColor='primary' saveText='close' cancelText="Close"
      @cancel='close'>
      <template v-slot:dialog-actions>
        <div style="display: flex; align-items: center; flex-direction: row; gap: 15px;">
          <v-btn small outlined text color='error' @click='show_cancel = true'>
            Cancel Staging
            <v-icon right small color="error">mdi-cancel</v-icon>
          </v-btn>
          <v-btn small outlined text color='info' @click='open'>
            Open Project
            <v-icon right small color="info">mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn small outlined text color='info' @click='show_activate_only = true'>
            Activate Only
            <v-icon right small color="info">mdi-check</v-icon>
          </v-btn>
          <v-btn small outlined text color='info' @click='loadPrev'>
            Prev
            <v-icon right small color="info">mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn small outlined text color='info' @click='loadNext'>
            Next
            <v-icon right small color="info">mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </template>
      <v-row>
        <v-col
          v-if='staging_project !== null && staging_project !== undefined && staging_project.project_data !== null && staging_project.project_data !== undefined'>
          <span class='headline'>{{ staging_project.project_data.name }}</span><br>
          <span class='subtitle-1'>{{ staging_project.project_data.site_address }}</span><br>
          <span class='body-2'>{{ staging_project.project_data.site_city }}</span><br>
          <v-icon v-if='staging_project.project.is_comm' color='primary' class='mb-2 ml-4'>mdi-domain</v-icon><br>
          <p>
            <span class='body-2'>Status:</span>
            <span class='body-1 font-weight-bold'>{{ status }}</span>
            <span style='padding-left: 10px;'>
              <staging-table-icon icon='mdi-swap-horizontal-bold' icon_active='mdi-swap-horizontal-bold' active_color=""
                :disabled="staging_project.resolved === true && staging_project.resolution === 'A'"
                @filter='show_move = true' text="Move" /> </span>
            <span>
              <staging-table-icon icon='mdi-snail' icon_active='mdi-snail' active_color="" @filter='downloadSnailMail'
                text="Snail Mail" /> </span>
            <span>
              <staging-table-icon icon='mdi-alpha-t-box-outline' icon_active='mdi-alpha-t-box-outline' active_color=""
                :disabled='staging_project.resolved' @filter='show_timeline = true' text="Show Timelines" /> </span>
            <span>
              <staging-table-icon icon='mdi-alpha-p-circle-outline' icon_active='mdi-alpha-p-circle-outline'
                active_color="" @filter='show_po = true' text="Show PO" />
            </span>
            <span>
              <v-tooltip top open-delay='500'>
                <template v-slot:activator='{ on }'>
                  <div v-on='on' class='d-inline-block'>
                    <v-btn icon small @click='overrideLock()' :disabled="!isLocked">
                      <v-icon>
                        {{ isLocked ? "mdi-lock" : "mdi-lock-open-variant" }}
                      </v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Lock</span>
              </v-tooltip>
            </span>
          </p>
        </v-col>
      </v-row>
      <v-row class="mt-n4">
        <v-col cols='12' v-if='show_dates'>
          <wc-data-box title="Service Overview" :titleIcon='icon' :titleIconColor='icon_color' :showEdit='true'
            @edit='show_service_overview = true'>
            <v-container>
              <v-row v-if='staging_project.pre_check_required' class='ml-2 purple--text font-weight-bold'>
                Sales must resolve Pre-check
              </v-row>
              <v-row>
                <v-col cols='6'>
                  <v-text-field disabled v-model='staging_project.start_date' label='Proposed Start Date'
                    style='padding-left: 25px; padding-right: 25px; margin-top: 10px;' />
                </v-col>
                <v-col cols='6'>
                  <v-text-field disabled v-model='staging_project.end_date' label='Proposed End Date'
                    style='padding-left: 25px; padding-right: 25px; margin-top: 10px;' />
                </v-col>
              </v-row>
            </v-container>

          </wc-data-box>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='6'>
          <wc-data-box title="Invoices" :titleIcon='icon' :titleIconColor='icon_color' :showEdit='false'>
            <template v-if='staging_project'>
              <span v-for='invoice in staging_project.invoice_to_project_data' :key='invoice.invoice'>
                <v-card-text style="cursor: pointer; padding-top: 5px; padding-bottom: 5px;"
                  @click='openInvoice(invoice)'>{{ invoice.invoice_data.number }}</v-card-text>
              </span>
            </template>

          </wc-data-box>
        </v-col>
        <v-col cols='6'>
          <wc-data-box title="Work Orders" :titleIcon='icon' :titleIconColor='icon_color' :showEdit='false'>
            <template v-if='staging_project'>
              <span v-for='work_order in staging_project.work_order_to_project_data' :key='work_order.work_order'>
                <v-card-text style="cursor: pointer; padding-top: 5px; padding-bottom: 5px;"
                  @click='openWorkOrder(work_order)'>{{ work_order.work_order_data.number }}</v-card-text>
              </span>
            </template>

          </wc-data-box>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols='12'>
          <wc-data-box title="Conflicts" titleIcon='mdi-alert-circle-outline' :titleIconColor='conflict_class'>
            <template v-slot:toolbarButtons v-if='!staging_project.resolved'>
              <v-tooltip top open-delay='500' disabled>
                <template v-slot:activator='{ on }'>
                  <v-btn v-on='on' x-small color='info' :disabled='staging_project.pre_check_required'
                    @click='show_conflict_resolution = true'>
                    <v-icon left small>{{ "mdi-debug-step-over" }}</v-icon>
                    Resolve Conflicts
                  </v-btn>
                </template>
                <span class='caption'>
                </span>
              </v-tooltip>
            </template>

            <div class='pa-4'>
              <template v-for='(conflict, index) in staging_project.conflict_data'>
                <div v-if='conflict.resolved === false' :class='conflict.can_ignore ? "warning--text" : "error--text"'
                  :key='index'>{{ conflict.value +
                    " - " + conflict.value_display }}
                </div>
              </template>
            </div>
          </wc-data-box>
        </v-col>

        <v-col cols='12'>
          <wc-data-box title="Staging Logs" titleIcon='mdi-format-list-bulleted' titleIconColor='grey darken-1'
            :showAdd='staging_project.resolved === false' @add='showLog'>

            <div class='pa-4'>
              <template v-for='log in staging_project.log_data'>
                <div :key='log.id'>
                  <span class='caption'>{{ log.date | shortDate }}</span>
                  <span class='caption grey--text ml-1'>{{ log.time | time }}</span>
                  <span class='body-2 ml-1 primary--text'>{{ log.taken_by_display }}</span>
                  <span>{{ ": " + log.action_taken }}</span>
                </div>
              </template>
            </div>
          </wc-data-box>
        </v-col>

      </v-row>
    </wc-dialog>

    <wc-dialog :showDialog='show_log_entry' title='Add manual log entry' subtitle='' width='600' saveText='Add'
      @save="createNewLog()" @cancel='show_log_entry = false'>
      <v-textarea label='Action Taken' persistent-hint v-model='action_taken'></v-textarea>
    </wc-dialog>

    <wc-dialog :showDialog='show_cancel' title='Cancel Staging' subtitle='' width='600' :body_text='cancel_text'
      cancelText='Close' saveText='Cancel Staging' @save="cancel()" @cancel='show_cancel = false'>
    </wc-dialog>

    <wc-dialog :showDialog='show_conflict_resolution' title='Resolve All Conflicts' subtitle='' width='600'
      body_text='Do you want to resolve all conflicts for this staging project?' cancelText='Close'
      saveText='Resolve Conflicts' @save='resolveConflicts()' @cancel='show_conflict_resolution = false'>
    </wc-dialog>

    <wc-dialog :showDialog='show_move' title='Move Staging Project' subtitle='' width='600'
      body_text='Which stage do you want to move the staging project?' cancelText='Close' saveText='Move Project'
      @save='moveStagingProject()' @cancel='show_move = false'>
      <v-select item-text="text" item-value="value" v-model="staging_project.stage" :items="stage_items" />
    </wc-dialog>
    <wc-dialog :showDialog='show_activate' title='Activate Project' width='600' saveText='Confirm' @save="activate()"
      @cancel='show_activate === false'>
      <v-col class='text-center'>
        <span>Activate and send confirmation?</span>
      </v-col>
    </wc-dialog>
    <wc-dialog :showDialog='show_activate_only' title='Activate Project' width='600' saveText='Confirm'
      @save="activateOnly()" @cancel='show_activate_only = false'>
      <v-col class='text-center'>
        <span>Activate without sending confirmation?</span>
      </v-col>
    </wc-dialog>

    <wc-dialog :showDialog='show_po' title='Update PO' width='600' saveText='Confirm' @save="updatePO()"
      @cancel='show_po = false'>
      <v-textarea label='PO' persistent-hint v-model='staging_project.po'></v-textarea>
    </wc-dialog>
    <wc-dialog :showDialog='show_timeline' title='Update Timeline' width='600' saveText='Confirm'
      @save="updateTimeline()" @cancel='show_timeline = false'>
      <v-select item-text="text" item-value="value" v-model="staging_project.timeline" :items="staging_project && staging_project.project_data && staging_project.project_data.is_comm ?
        timeline_items.filter(item => item.value !== 'ERS10' && item.value !== 'PO1') : timeline_items" />
    </wc-dialog>
    <wc-dialog :showDialog='confirm_uncancel' title='Uncancel Staging Project' width='600'
      body_text='Are you sure you want to uncancel this staging project?' saveText='Confirm' @save="uncancelStaging()"
      @cancel='confirm_uncancel = false'>
    </wc-dialog>
    <wc-dialog :showDialog='show_service_overview' title='Edit Upcoming Season Details' width='400' saveText='Save'
      @save='saveDates()' @cancel='show_service_overview = false'>
      <v-form>
        <v-row>
          <v-col cols='12'>
            <wc-datepicker required label='Proposed Start Date' v-model='staging_project.start_date'
              :hint='"Previous Season Start Date was: " + staging_project.start_date' persistent-hint></wc-datepicker>
          </v-col>
          <v-col cols='12'>
            <wc-datepicker required label='Proposed End Date' v-model='staging_project.end_date'
              :hint='"Previous Season End Date was: " + staging_project.end_date' persistent-hint></wc-datepicker>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>
